import { requestServise } from "@/shared";
import $api from "@/shared/http";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { IApiError } from "@/app/model/types";
import {
  DealerEditBodyType,
  IDealer,
  IOrderedDealer,
  ProductionOrderBodyType,
  ProlongationBodyType,
} from "../../model/types";

export const changeOrderDate = createAsyncThunk<
  { items: IOrderedDealer[] },
  ProlongationBodyType,
  { rejectValue: string }
>("dealer/changeOrderDate", async (body, { rejectWithValue }) => {
  try {
    const response = await $api.put("/dealer/prolongation", body);

    return await response.data.data;
  } catch (error) {
    return rejectWithValue("Ошибка изменения даты пролонгации");
  }
});

export const createProductionOrder = createAsyncThunk<
  void,
  ProductionOrderBodyType,
  { rejectValue: string }
>("dealer/createProductionOrder", async (body, { rejectWithValue }) => {
  try {
    await $api.post("/dealer/prolongation-order", body);
  } catch (error) {
    return rejectWithValue("Ошибка формирования заказа ПД");
  }
});

export const editDealer = createAsyncThunk<
  DealerEditBodyType,
  Partial<IDealer>,
  { rejectValue: IApiError }
>(
  "dealer/editDealer",
  async (body: DealerEditBodyType, { rejectWithValue }) => {
    try {
      const response = await $api.put("/dealer", body);
      return response.data;
    } catch (error) {
      const axiosError = error as {
        response?: {
          data: IApiError;
          status: number;
        };
        message: string;
      };
      if (error.response.status === 500) {
        return rejectWithValue({
          title: "Ошибка",
          status: 500,
          detail: "Ошибка при создании дилера, Обратитесь в службу поддержки",
        });
      }

      return rejectWithValue(
        axiosError.response?.data || {
          title: "Ошибка",
          status: axiosError.response?.status || 500,
          detail: axiosError.message || "Неизвестная ошибка",
        },
      );
    }
  },
);

export const addDealerBranch = createAsyncThunk<
  IDealer,
  Partial<IDealer>,
  { rejectValue: IApiError }
>(
  "dealer/addDealerBranch",
  async (body: Partial<IDealer>, { rejectWithValue }) => {
    try {
      const response = await $api.post("/dealer/create", body);
      return response.data;
    } catch (error) {
      const axiosError = error as {
        response?: {
          data: IApiError;
          status: number;
        };
        message: string;
      };
      if (error.response.status === 500) {
        return rejectWithValue({
          title: "Ошибка",
          status: 500,
          detail: "Ошибка при создании дилера, Обратитесь в службу поддержки",
        });
      }

      return rejectWithValue(
        axiosError.response?.data || {
          title: "Ошибка",
          status: axiosError.response?.status || 500,
          detail: axiosError.message || "Неизвестная ошибка",
        },
      );
    }
  },
);

export const deleteDealerBranch = requestServise.deleteWithBody<{ id: string }>(
  "dealer/deleteDealerBranch",
  "/dealer",
);

export const setMainDealerBranch = requestServise.put<{
  oldId: string;
  newId: string;
}>("dealer/setMainDealerBranch", "/dealer/main");
